import React from 'react'
import Icon from 'react-fa'
import {Modal, ProgressBar} from 'react-bootstrap'
import {t} from '../../helpers/translate'

export default class LoadingComponent extends React.Component {
  constructor(props) {
    super(props);
  }

  getText(){
    return this.props.text ? t(this.props.text) : t('Loading');
  }

  render() {
    return <Modal bsSize="small" show={this.props.show}>
      <Modal.Body>
        <div className={`div-center ${sessionStorage.getItem('org')}`}>
          <ProgressBar bsStyle={this.props.hasError ? 'danger' : null} striped active={!this.props.hasError} now={100}/> 
          <h3>{this.props.hasError ? t(`Error ${this.props.statusCode}`) : this.getText()}</h3>
        </div>
      </Modal.Body>
    </Modal>;
  }
}


// WEBPACK FOOTER //
// ./src/components/common/LoadingComponent.js